import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconShieldAchieve = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 22,
	viewBox: "0 0 21 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M19.1133 4.07031L11.2383 0.789062C11.0332 0.707031 10.7051 0.666016 10.5 0.666016C10.2539 0.666016 9.92578 0.707031 9.7207 0.789062L1.8457 4.07031C1.10742 4.39844 0.65625 5.0957 0.65625 5.875C0.65625 16.457 8.4082 21.625 10.459 21.625C12.5918 21.625 20.3438 16.375 20.3438 5.875C20.3438 5.0957 19.8516 4.39844 19.1133 4.07031ZM14.4375 8.82812C14.4375 9.07422 14.3555 9.32031 14.1914 9.48438L10.2539 14.0781C9.9668 14.4062 9.59766 14.4062 9.51562 14.4062C9.22852 14.4062 8.98242 14.2832 8.81836 14.1191L6.84961 12.1504C6.64453 11.9863 6.5625 11.7402 6.5625 11.4531C6.5625 10.9199 6.97266 10.4688 7.54688 10.4688C7.79297 10.4688 8.03906 10.5508 8.20312 10.7559L9.43359 11.9453L12.6738 8.17188C12.8789 7.92578 13.166 7.84375 13.4531 7.84375C14.1914 7.84375 14.4375 8.54102 14.4375 8.82812Z",
		fill: "#38539A"
	})]
});
const ForwardRef = forwardRef(SvgIconShieldAchieve);
export { ForwardRef as ReactComponent };
